import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import {
  Box,
  Typography,
  Grid,
  Chip,
  Divider,
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";
import { Phone, LocationOn, Star, Directions, Flight, Restaurant } from "@mui/icons-material";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { IconButton } from "@mui/material";
import { ArrowForward } from "@mui/icons-material";
import { styled } from "@mui/system";
import {
  Pool, Wifi, FitnessCenter, LocalParking, Spa,
  LocalBar, BusinessCenter, AcUnit, Pets, RoomService, AirportShuttle,
  Lock, Luggage, Newspaper, Elevator, Room, SupportAgent,
  ConfirmationNumber, Accessible, Coffee, Bathroom, MeetingRoom,
  LocalLaundryService, SmokeFree, DirectionsCar, AirlineSeatFlat
} from "@mui/icons-material";
import BookingValidation from "./BookingValidation";
import { useBooking } from "./BookingContext";


const SwipeButton = styled(IconButton)(({ processing }) => ({
  background: "linear-gradient(90deg, #ff7e5f, #feb47b)", // Initial gradient
  color: "white",
  padding: "15px",
  borderRadius: "50%",
  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.2)",
  transition: "background 0.5s ease-in-out",
  animation: processing ? "fillColor 2s forwards" : "pulse 2s infinite",

  "@keyframes pulse": {
    "0%": { transform: "scale(1)" },
    "50%": { transform: "scale(1.05)" },
    "100%": { transform: "scale(1)" },
  },

  "@keyframes fillColor": {
    "0%": { background: "linear-gradient(90deg, rgb(92, 25, 86), rgb(220, 22, 19))" },
    "50%": { background: "linear-gradient(90deg, rgb(142, 216, 21), rgb(10, 69, 247))" },
    "100%": { background: "linear-gradient(90deg, #ff7e5f, #feb47b)" },
  },

  "&:hover": {
    transform: "none", // Prevent movement on hover
  },
}));
const BookingHotel = () => {
  const [processing, setProcessing] = useState(false);
  const { setBookingCode } = useBooking(); // Use the context

  const [hotelData, setHotelData] = useState(null);
  const [hotelValidation, setHotelValidation] = useState(null);
  const location = useLocation();
  const hotel = location.state?.hotel;
  console.log("BookingHotel", hotel);
  const facilityIcons = {
    "Swimming Pool": <Pool />,
    "Free WiFi": <Wifi />,
    "Gym": <FitnessCenter />,
    "Restaurant": <Restaurant />,
    "Parking": <LocalParking />,
    "Spa": <Spa />,
    "Bar": <LocalBar />,
    "Business Center": <BusinessCenter />,
    "Air Conditioning": <AcUnit />,
    "Pet Friendly": <Pets />,
    "Room Service": <RoomService />,
    "Airport Shuttle": <AirportShuttle />,
    "Safe-deposit box at front desk": <Lock />,
    "Luggage storage": <Luggage />,
    "Newspapers in lobby (surcharge)": <Newspaper />,
    "Elevator": <Elevator />,
    "Concierge services": <SupportAgent />,
    "24-hour front desk": <Room />,
    "Tours/ticket assistance": <ConfirmationNumber />,
    "Wheelchair accessible path of travel": <Accessible />,
    "Coffee shop or café": <Coffee />,
    "Accessible bathroom": <Bathroom />,
    "One meeting room": <MeetingRoom />,
    "Free self parking": <LocalParking />,
    "Dry cleaning/laundry service": <LocalLaundryService />,
    "Free valet parking": <DirectionsCar />,
    "Smoke-free property": <SmokeFree />,
    "Braille or raised signage": <AirlineSeatFlat />,
    "In-room accessibility": <Accessible />,
    "Wheelchair accessible parking": <Accessible />,
  }
  if (!hotel) {
    return <Typography variant="h6">No hotel data found.</Typography>;
  }

  const renderStars = (rating) =>
    Array.from({ length: 5 }, (_, i) =>
      i < rating ? (
        <Star key={i} sx={{ color: "#FFD700", fontSize: "1.2rem" }} />
      ) : (
        <Star key={i} sx={{ color: "#ddd", fontSize: "1.2rem" }} />
      )
    );




  // Parse and structure the attractions data
  const parseAttractions = (attractions) => {
    const parser = new DOMParser();
    const doc = parser.parseFromString(attractions, "text/html");
    const attractionsList = [];
    const airportsList = [];

    doc.querySelectorAll("p").forEach((p) => {
      if (p.textContent.includes("km") || p.textContent.includes("mi")) {
        if (p.textContent.includes("airports")) {
          airportsList.push(p.textContent.trim());
        } else {
          attractionsList.push(p.textContent.trim());
        }
      }
    });

    return { attractionsList, airportsList };
  };
  const { attractionsList, airportsList } = parseAttractions(hotel.Attractions["1) "]);
  const handleBookNowClick = async () => {
    const bookingCode = hotel.Rooms[0].BookingCode;
    setBookingCode(bookingCode); // Store the bookingCode in context

    console.log(bookingCode);

    const authToken = sessionStorage.getItem('jwtToken'); // Replace with your actual auth token
    const apiUrl = 'https://api.ipaisa.co.in/myapp/hotels/prebook';

    try {
      const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${authToken}`
        },
        body: JSON.stringify({
          BookingCode: bookingCode,
          PaymentMode: 'Limit'
        })
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      console.log('API Response:', data);

      if (data.HotelResult && data.HotelResult.length > 0) {
        setHotelData(data.HotelResult[0]); // Store the first hotel result in state
      }

      if (data.ValidationInfo) {
        setHotelValidation(data.ValidationInfo); // Store the validation info in state
        console.log('Validation Info:', data.ValidationInfo);
      }
    } catch (error) {
      console.error('There was a problem with the API call:', error);
    }
    setTimeout(() => {
      setProcessing(false);
    }, 2000);
  };



  return (
    <Box sx={{ padding: 3, maxWidth: 1200, margin: "0 auto", marginTop: "4%" }}>
      {/* Hotel Name and Rating */}
      <Box sx={{ position: "relative", height: 300, mb: 4 }}>
        <img
          src={hotel.ImageUrl}
          alt={hotel.HotelName}
          style={{ width: "100%", height: "100%", objectFit: "cover" }}
        />
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background: "linear-gradient(to top, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.3))",
            padding: 3,
          }}
        >
          <Typography variant="h3" fontWeight="bold" color="white">
            {hotel.HotelName}
          </Typography>
          <Box display="flex" alignItems="center" gap={1}>
            {renderStars(hotel.HotelRating)}
            <Typography variant="body1" color="white">
              {hotel.HotelRating}-Star Hotel
            </Typography>
          </Box>
        </Box>
      </Box>



      {/* Address and Contact */}
      <Grid container spacing={2} mb={4}>
        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <LocationOn color="primary" />
            <Typography variant="body1">{hotel.Address}</Typography>
          </Box>
        </Grid>
        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" gap={1}>
            <Phone color="primary" />
            <Typography variant="body1">
              {hotel.PhoneNumber}
            </Typography>
          </Box>
        </Grid>
      </Grid>

      <Divider sx={{ my: 3 }} />



      {hotel.Rooms.map((room, index) => (
        <Accordion key={index} sx={{ mb: 2, transition: "all 0.3s", "&:hover": { boxShadow: 3 } }}>
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>
            <Typography variant="h6" fontWeight="bold">{room.Name.join(", ")}</Typography>
          </AccordionSummary>
          <AccordionDetails>
            <Box display="flex" alignItems="center" gap={1} mb={1}>
              <Restaurant color="primary" />
              <Typography variant="body1" color="text.secondary">{room.MealType}</Typography>
            </Box>
            <Box mt={2}>
              <Typography variant="body1">
                <strong>Total Fare:</strong>{" "}
                <span style={{ color: "#4CAF50", fontWeight: "bold" }}>
                  {hotel.Currency} {room.TotalFare.toFixed(2)}
                </span>
              </Typography>
              <Typography variant="body1">
                <strong>Tax:</strong> {hotel.Currency} {room.TotalTax.toFixed(2)}
              </Typography>
              <Typography variant="body1">
                <strong>Inclusion:</strong> {room.Inclusion}
              </Typography>
              <Typography variant="body1" sx={{ color: "red" }}>
                <strong>Promotion:</strong> {room.RoomPromotion.join(", ")}
              </Typography>
              <Typography variant="body1" color="error">
                <strong>Cancellation Policy:</strong>{" "}
                {room.CancelPolicies.map((policy, i) => (
                  <span key={i}>
                    From {policy.FromDate}: {policy.CancellationCharge}% charge
                  </span>
                ))}
              </Typography>
            </Box>
          </AccordionDetails>
        </Accordion>
      ))}

      <Divider sx={{ my: 3 }} />

      {/* Hotel Facilities */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Hotel Facilities
      </Typography>
      <Grid container spacing={1}>
        {hotel.HotelFacilities.map((facility, index) => (
          <Grid item key={index}>
            <Tooltip title={facility} arrow>
              <Chip
                icon={facilityIcons[facility] || null}
                label={facility}
                variant="outlined"
                sx={{ backgroundColor: "#e3f2fd", fontWeight: "bold" }}
              />
            </Tooltip>
          </Grid>
        ))}
      </Grid>


      <Divider sx={{ my: 3 }} />
      <Typography variant="h5" fontWeight="bold" gutterBottom>Location</Typography>
      <Box sx={{ height: 300, borderRadius: 3, overflow: "hidden" }}>
        <iframe
          title="hotel-location"
          width="100%"
          height="100%"
          style={{ border: 0 }}
          src={`https://www.google.com/maps?q=${encodeURIComponent(hotel.Address)}&output=embed`}
          allowFullScreen
        />
      </Box>
      <Box sx={{ padding: 3, maxWidth: 1200, margin: "0 auto", marginTop: "4%" }}>
        {/* Nearby Attractions */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Nearby Attractions
        </Typography>
        <List>
          {attractionsList.map((attraction, index) => (
            <ListItem key={index} sx={{ "&:hover": { backgroundColor: "#f5f5f5" } }}>
              <ListItemIcon>
                <Directions color="primary" />
              </ListItemIcon>
              <ListItemText primary={attraction} />
            </ListItem>
          ))}
        </List>


        {/* Nearby Airports */}
        <Typography variant="h5" fontWeight="bold" gutterBottom>
          Nearby Airports
        </Typography>
        <List>
          {airportsList.map((airport, index) => (
            <ListItem key={index}>
              <ListItemIcon>
                <Flight color="primary" />
              </ListItemIcon>
              <ListItemText primary={airport} />
            </ListItem>
          ))}
        </List>
      </Box>



      <Divider sx={{ my: 3 }} />

      {/* Hotel Description */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>Hotel Description</Typography>
      <Box sx={{ lineHeight: 1.6 }} dangerouslySetInnerHTML={{ __html: hotel.Description }} />



      <Divider sx={{ my: 3 }} />

      {/* Check-In/Check-Out */}
      <Typography variant="h5" fontWeight="bold" gutterBottom>
        Check-In & Check-Out
      </Typography>
      <Typography variant="body1">
        <strong>Check-In:</strong> {hotel.CheckInTime}
      </Typography>
      <Typography variant="body1">
        <strong>Check-Out:</strong> {hotel.CheckOutTime}
      </Typography>

      {/* Book Now Button */}
      <Box
        sx={{
          position: "fixed",
          bottom: 20,
          right: 20,
          zIndex: 1000,
        }}
      >
        <SwipeButton onClick={handleBookNowClick} processing={processing}>
          <ArrowForward fontSize="large" />
        </SwipeButton>
      </Box>
      {hotelData && <BookingValidation hotelData={hotelData} hotelValidation={hotelValidation} />}

    </Box>
  );
};

export default BookingHotel;
